import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { 
    IonPage, 
    IonContent, 
} from '@ionic/vue';

import TopNavigation from '@/partials/TopNavigation.vue';
import BottomNavigation from '@/partials/BottomNavigation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLayout',
  props: {
    showFooter: {
        type: Boolean,
        default: true,
    },
    color: {
        type: String
    }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(TopNavigation),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "",
        color: __props.color
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default"),
          (__props.showFooter)
            ? (_openBlock(), _createBlock(BottomNavigation, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["color"])
    ]),
    _: 3
  }))
}
}

})